module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<html>\n  <head>\n    <title><%- appName %></title>\n    <meta charset="utf-8" />\n    <% if (webExport) { -%>\n    <meta name="viewport" content="width=device-width, initial-scale=1">\n    <% } else { -%>\n    <meta name="viewport" content="width=<%- appWidth %>, minimal-ui, target-densityDpi=device-dpi, user-scalable=no">\n    <% } -%>\n    <script src="<%- jQueryPath %>"></script>\n    <% if (webpackRuntimePath) { -%>\n      <script src="<%- webpackRuntimePath %>"></script>\n    <% } -%>\n    <script src="<%- gamelabApiPath %>"></script>\n    <link href="<%- gamelabCssPath %>" rel="stylesheet" type="text/css">\n    <script src="<%- p5Path %>"></script>\n    <script src="<%- p5playPath %>"></script>\n    <script src="<%- codePath %>"></script>\n    <style>\n      body.expo {\n        background-color: black;\n      }\n      #sketch.expo.no-controls {\n        top: 82px;\n      }\n    </style>\n  </head>\n  <body class="<%- exportClass %>" style="margin:0; overflow:hidden; user-select:none; -webkit-user-select:none; -webkit-touch-callout:none; position:fixed; top:0; left:0; width:<%- appWidth %>px; height:<%- appHeight %>px;">\n    <div id="sketch" class="<%- exportClass %>" style="position:absolute;"></div>\n    <div id="soft-buttons" style="display: none">\n      <button id="leftButton" disabled className="arrow">\n      </button>\n      <button id="rightButton" disabled className="arrow">\n      </button>\n      <button id="upButton" disabled className="arrow">\n      </button>\n      <button id="downButton" disabled className="arrow">\n      </button>\n    </div>\n    <div id="studio-dpad-container" style="position:absolute; width:400px; bottom:5px; height:157px; overflow-y:hidden;">\n    </div>\n  </body>\n</html>\n', __filename = "src/templates/export/gamelabIndex.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __append("<html>\n  <head>\n    <title>");
            __line = 3;
            __append(appName);
            __append('</title>\n    <meta charset="utf-8" />\n    ');
            __line = 5;
            if (webExport) {
                __append('    <meta name="viewport" content="width=device-width, initial-scale=1">\n    ');
                __line = 7;
            } else {
                __append('    <meta name="viewport" content="width=');
                __line = 8;
                __append(appWidth);
                __append(', minimal-ui, target-densityDpi=device-dpi, user-scalable=no">\n    ');
                __line = 9;
            }
            __append('    <script src="');
            __line = 10;
            __append(jQueryPath);
            __append('"></script>\n    ');
            __line = 11;
            if (webpackRuntimePath) {
                __append('      <script src="');
                __line = 12;
                __append(webpackRuntimePath);
                __append('"></script>\n    ');
                __line = 13;
            }
            __append('    <script src="');
            __line = 14;
            __append(gamelabApiPath);
            __append('"></script>\n    <link href="');
            __line = 15;
            __append(gamelabCssPath);
            __append('" rel="stylesheet" type="text/css">\n    <script src="');
            __line = 16;
            __append(p5Path);
            __append('"></script>\n    <script src="');
            __line = 17;
            __append(p5playPath);
            __append('"></script>\n    <script src="');
            __line = 18;
            __append(codePath);
            __append('"></script>\n    <style>\n      body.expo {\n        background-color: black;\n      }\n      #sketch.expo.no-controls {\n        top: 82px;\n      }\n    </style>\n  </head>\n  <body class="');
            __line = 28;
            __append(exportClass);
            __append('" style="margin:0; overflow:hidden; user-select:none; -webkit-user-select:none; -webkit-touch-callout:none; position:fixed; top:0; left:0; width:');
            __append(appWidth);
            __append("px; height:");
            __append(appHeight);
            __append('px;">\n    <div id="sketch" class="');
            __line = 29;
            __append(exportClass);
            __append('" style="position:absolute;"></div>\n    <div id="soft-buttons" style="display: none">\n      <button id="leftButton" disabled className="arrow">\n      </button>\n      <button id="rightButton" disabled className="arrow">\n      </button>\n      <button id="upButton" disabled className="arrow">\n      </button>\n      <button id="downButton" disabled className="arrow">\n      </button>\n    </div>\n    <div id="studio-dpad-container" style="position:absolute; width:400px; bottom:5px; height:157px; overflow-y:hidden;">\n    </div>\n  </body>\n</html>\n');
            __line = 44;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}